import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RaciTemplateService } from 'src/app/modules/app-settings/services/raci-template-service';
import { DestroyBase } from '../../../components/common/ng-destroy-base';
import { RaciStepTemplateModel } from '../../../modules/app-settings/models/raci-step-template-model';
import { RaciTaskTemplateModel } from '../../../modules/app-settings/models/raci-task-template-model';
import { RaciTemplateModel } from '../../../modules/app-settings/models/raci-template-model';
import { AdminTabs } from '../../enum';
import { NavigationService } from '../../navigation.service';

/**
 * Handles the raci template navigation component
 */
@Component({
  selector: 'raci-template-navigation',
  templateUrl: './raci-template-navigation.component.html',
  styleUrls: ['./raci-template-navigation.component.css']
})
export class RaciTemplateNavigationComponent extends DestroyBase implements OnInit {
  /**
   * Search active flag
   */
  searchActive = false;
  /**
   * Disable edit flag
   */
  disableEdit = true;
  /**
   * Selected template id
   */
  selectedTemplateId = 0;
  /**
   * Selected template model
   */
  selectedTemplateModel: RaciTemplateModel;
  /**
   * Steps
   */
  steps: RaciStepTemplateModel[] = [];
  /**
   * All tasks
   */
  allTasks: RaciTaskTemplateModel[] = [];

  /**
   * Cinstructor
   * @param navigationService
   * @param rtService
   * @param ref
   */
  constructor(
    private navigationService: NavigationService,
    private rtService: RaciTemplateService,
    private ref: ChangeDetectorRef) { super(); }

  /**
  * Initializes the component
  */
  ngOnInit(): void {
    this.subscriptions.add(this.rtService.disableEdit$.subscribe(disableEdit => {
      this.disableEdit = disableEdit;
      this.ref.markForCheck();
    }));

    this.selectedTemplateId = this.rtService.getSelectedTemplateId();
  }

  /**
  * Sets the active tab
  * @param tab The active tab
  */
  setActiveTab(tab: AdminTabs) {
    this.navigationService.setActiveAdminTab(tab);
  }

  /**
  * Gets the AdminTabs enum
  */
  public get AdminTab(): typeof AdminTabs {
    return AdminTabs;
  }

  /**
   * Edit mode - does nothing currently
   */
  edit() {
    //Nothing
  }

  /**
  * Triggers the search action
  */
  search() {
    this.searchActive = !this.searchActive;
    this.rtService.setSearchActive(this.searchActive);
  }

  /**
  * Triggers the reset search action
  */
  resetSearch() {
    this.rtService.triggerResetSearch();
  }

  /**
   * Copy template
   */
  copy() {
    const raciTemplate = this.rtService.getSelectedTemplate();
    this.selectedTemplateId = raciTemplate.oid;
    this.rtService.get(this.selectedTemplateId).subscribe(result => {
      this.selectedTemplateModel = result;
      this.steps = result.steps;
      this.allTasks = result.tasks;
      this.selectedTemplateModel.name += ' - Copy';
      this.steps.forEach(step => {
        step.tasks = this.allTasks.filter(task => task.stepId === step.oid);
      });

      this.rtService.copy(this.selectedTemplateModel).subscribe(() => {
        this.refreshTemplateGrid();
      });
    });
  }

  /**
  *  Template grid refresh
  */
  refreshTemplateGrid() {
    this.navigationService.setActiveAdminTab(AdminTabs.RaciTemplateNone);
    setTimeout(() => {
      this.navigationService.setActiveAdminTab(AdminTabs.RaciTemplate);
    });
  }
}
